import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Form, Modal, Input } from "antd";
const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({});

class OnlineAddModel extends React.Component {
    static propTypes = {
        addShow: PropTypes.bool,
        onModalOk: PropTypes.func,
        onModalCancel: PropTypes.func,
        confirmLoading:PropTypes.bool,
    };

    handleSubmit = e => {
        e.preventDefault();
    };
    
    //提交数据
    handleAddModalOk = e => {
        const { form, onModalOk } = this.props;
        form.validateFieldsAndScroll((err, values) => {
            const send={
                remark:values.note,
                count:values.count,
            }
            onModalOk(send)
        })
    };
    
    render() {
        const {
            addShow,
            confirmLoading,
            onModalCancel,
        } = this.props;
        if (!addShow) {
            return null;
        }
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tltle =  `添加线上用户`;
        const no =false;
        return (
            <Modal
                title={tltle}
                centered
                destroyOnClose
                confirmLoading={confirmLoading}
                visible={addShow}
                onOk={this.handleAddModalOk}
                onCancel={onModalCancel}
                maskClosable={no}
            > 
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item {...formItemLayout} label="备注">
                        {getFieldDecorator("note", {
                            rules: [
                                {
                                    required: true,
                                    message: "请输入备注!",
                                },
                                {
                                    pattern: new RegExp(/^.{1,50}$/),
                                    required: true,
                                    message: "相关合作平台线上订单号或者备注 ，最多50个汉字!",
                                },
                            ],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="授权下载次数(>0)">
                        {getFieldDecorator("count", {
                            rules: [
                                {
                                    required: true,
                                    message: "请输入授权下载次数!",
                                },
                                {
                                    // 非零的正整数
                                    pattern: new RegExp(/^[1-9]\d*$/),
                                    required: true,
                                    message: "授权下载次数只能是>0的整数!",
                                },
                            ],
                        })(<Input />)}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: "OnlineAddModel" })(OnlineAddModel));
